import type { Stage } from "../api/types";
import { STEPPER_STEPS, chapterCounterLabel, stepperIndexForStage } from "../lib/stage";
import { CheckIcon } from "./Icon";

interface StageStepperProps {
  stage: Stage | null;
  chaptersDone: number;
  chaptersTotal: number | null;
}

type StepState = "done" | "active" | "pending";

export default function StageStepper({ stage, chaptersDone, chaptersTotal }: StageStepperProps) {
  const activeIndex = stepperIndexForStage(stage);

  return (
    <ol className="flex flex-col">
      {STEPPER_STEPS.map((step, i) => {
        const state: StepState = activeIndex < 0 ? "pending" : i < activeIndex ? "done" : i === activeIndex ? "active" : "pending";
        const isLast = i === STEPPER_STEPS.length - 1;
        const showChapters = state === "active" && (step.key === "write" || step.key === "verify");

        return (
          <li key={step.key} className="relative flex gap-4 pb-7 last:pb-0">
            {!isLast ? (
              <span
                className={`absolute left-[11px] top-6 h-[calc(100%-1.25rem)] w-px ${
                  state === "done" ? "bg-accent" : "bg-border"
                }`}
                aria-hidden="true"
              />
            ) : null}

            <span
              className={
                "relative z-10 mt-0.5 flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full border-2 " +
                (state === "done"
                  ? "border-accent bg-accent text-white"
                  : state === "active"
                    ? "border-accent bg-bg text-accent animate-pulse-soft"
                    : "border-border bg-bg text-muted")
              }
            >
              {state === "done" ? <CheckIcon width={12} height={12} /> : <span className="h-1.5 w-1.5 rounded-full bg-current" />}
            </span>

            <div className="flex-1">
              <p
                className={
                  "text-[15px] leading-[22px] " +
                  (state === "active" ? "font-semibold text-text" : state === "done" ? "text-text" : "text-muted")
                }
              >
                {step.label}
              </p>
              {showChapters ? (
                <p className="mt-0.5 text-sm text-muted">{chapterCounterLabel(chaptersDone, chaptersTotal)}</p>
              ) : null}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
